import { ExportIcon } from 'assets/icons/ExportIcon'
import { PlusIcon } from 'assets/icons/PlusIcon'

import { Button, Flex, OutlineButton } from 'styling/GlobalStyles'

export const PurchaseRequestActions = () => {
  return (
    <>
      <OutlineButton width='140'>
        {ExportIcon}
        Export
      </OutlineButton>
      <Button orange width='220'>
        <Flex gap='0.5rem'>
          {PlusIcon}
          Create purchase request
        </Flex>
      </Button>
    </>
  )
}
